import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import { gql } from '@apollo/client';
import client from 'apolloClient';

type IRequestStatus = 'idle' | 'loading' | 'failed';

export interface IUserState {
  username: string;
  email: string;
  userRequestStatus: IRequestStatus;
}

const initialState: IUserState = {
  username: '',
  email: '',
  userRequestStatus: 'idle',
};

export const fetchUser = createAsyncThunk('user', async (token: string) => {
  const GET_USERNAME = gql`
    query {
      currentUser {
        username
        avatarUrl
        emails {
          nodes {
            email
          }
        }
        groupMemberships {
          nodes {
            group {
              fullPath
            }
          }
        }
      }
    }
  `;
  const response = await client.query({
    query: GET_USERNAME,
    context: { headers: { authorization: `Bearer ${token}` } },
  });
  return response.data;
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.userRequestStatus = 'loading';
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.userRequestStatus = 'idle';
        state.username = action.payload.currentUser.username;

        if (action.payload.currentUser.emails?.nodes?.length > 0) {
          state.email = action.payload.currentUser.emails.nodes[0].email;
        }
      })
      .addCase(fetchUser.rejected, (state) => {
        state.userRequestStatus = 'failed';
      });
  },
});

export const selectUser = (state: RootState): string => state.user.username;
export const selectEmail = (state: RootState): string => state.user.email;

export default userSlice.reducer;
